import $ from 'jquery';
import Cookies from 'js-cookie';

$(document).ready(() => {
    $('.st_news_letter_popup_wrap').each(function(){
        let popup = $(this);
        if(popup.data('hide_on_mobile'))
            popup.on('show.bs.modal', function (event) {
                if(sttheme.st_responsive && $(window).width()<992)
                    return false;
            });
        if(popup.data('delay_popup'))
            setTimeout(function(){popup.modal('show');}, popup.data('delay_popup') * 1000);
        else
            popup.modal('show');

        let id_st = popup.data('id_st');
        let show_popup = popup.data('show_popup');
        let cookies_time = popup.data('cookies_time');
        $('.st_news_letter_do_not_show').change(function () {
            if ($(this).is(':checked')) {
                Cookies.set('st_popup_do_not_show_'+id_st, show_popup, {
                    'expires': cookies_time ? cookies_time : 30,
                    'domain': sttheme.cookie_domain,
                    'path': sttheme.cookie_path
                });
            } else {
                Cookies.set('st_popup_do_not_show_'+id_st, show_popup, {
                    'expires':-1,
                    'domain': sttheme.cookie_domain,
                    'path': sttheme.cookie_path
                }); 
            }
        });
        if(show_popup==2)
            Cookies.set('st_popup_do_not_show_'+id_st, show_popup, {
                'expires': cookies_time ? cookies_time : 30,
                'domain': sttheme.cookie_domain,
                'path': sttheme.cookie_path
            });
    });

    $('form.st_news_letter_form').submit(function(){
        var $form = $(this);
        if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/.test($(this).find('.st_news_letter_input').val()))
        {
           $form.closest('.st_news_letter_box').find('.alert-danger').html(wrongemailaddress_stnewsletter).removeClass('hidden');
           return false;
        }
        
        $.ajax(
        {
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            cache: false,
            success: function(result)
            {
                $form.closest('.st_news_letter_box').find('.alert-danger, .alert-success').addClass('hidden');
                if (result.hasError)
                    $form.closest('.st_news_letter_box').find('.alert-danger').html(result.hasError).removeClass('hidden');
                else
                {
                    $form.closest('.st_news_letter_box').find('.alert-success').html(result.message).removeClass('hidden');
                    let popup = $form.closest('.st_news_letter_popup_wrap');
                    if (popup.length)
                        Cookies.set('st_popup_do_not_show_'+popup.data('id_st'), popup.data('show_popup'), {
                            'domain': sttheme.cookie_domain,
                            'path': sttheme.cookie_path
                        });
                }  
            }
        });
        return false;
    });
});



// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js


// WEBPACK FOOTER //
// ./js/stnewsletter.js